<template>
  <v-container fluid class="product-page pa-4">
    <div class="product-top-card">
      <div class="product-header">
        <div class="product-title-wrap">
          <v-btn icon small class="mr-2" to="/product/home">
            <v-icon>mdi-home-outline</v-icon>
          </v-btn>

          <div>
            <div class="product-title">Product</div>
            <div class="product-subtitle">
              Manage products, categories, departments, brands, and pricing.
            </div>
          </div>
        </div>

        <v-menu offset-y left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small rounded color="primary" dark v-bind="attrs" v-on="on">
              <v-icon left small>{{ selectedIcon }}</v-icon>
              {{ selectedLabel }}
              <v-icon right small>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list dense class="product-menu">
            <v-list-item
              v-for="item in menuItems"
              :key="item.label"
              :disabled="item.disabled"
              :class="{ 'active-menu-item': selectedLabel === item.label }"
              @click="selectItem(item)"
            >
              <v-list-item-icon>
                <v-icon small>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{ item.label }}</v-list-item-title>

              <v-list-item-action v-if="selectedLabel === item.label">
                <v-icon small color="primary">mdi-check</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <div class="product-route-content">
      <router-view />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "product",

  data() {
    return {
      selectedLabel: "Product List",
      selectedIcon: "mdi-package-variant-closed",
    };
  },

  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),

    hasCollections() {
      return !!(
        this.currentBusiness &&
        this.currentBusiness.metadata &&
        this.currentBusiness.metadata.collections
      );
    },

    showPriceTier() {
      return !!(
        this.currentBusiness &&
        this.currentBusiness.metadata &&
        !this.currentBusiness.metadata.isSingleCustomerPricing
      );
    },

    menuItems() {
      const items = [
        {
          label: "Product List",
          icon: "mdi-package-variant-closed",
          route: "/product/list",
        },
        {
          label: "Collections",
          icon: "mdi-folder-multiple-outline",
          route: "/product/collection/list",
          disabled: !this.hasCollections,
        },
        {
          label: "Category",
          icon: "mdi-shape-outline",
          route: "/product/category/list",
        },
        {
          label: "Department",
          icon: "mdi-sitemap-outline",
          route: "/product/department/list",
        },
        {
          label: "Brand",
          icon: "mdi-tag-outline",
          route: "/product/brand/list",
        },
      ];

      if (this.showPriceTier) {
        items.push({
          label: "Price Tier",
          icon: "mdi-cash-multiple",
          route: "/product/PriceTier/list",
        });
      }

      return items;
    },
  },

  watch: {
    $route(to) {
      this.updateSelectedFromPath(to.path);
    },
  },

  created() {
    this.updateSelectedFromPath(this.$route.path);
    document.title = "smplsale - Product";
  },

  methods: {
    selectItem(item) {
      if (!item || item.disabled) {
        return;
      }

      this.selectedLabel = item.label;
      this.selectedIcon = item.icon;

      if (this.$route.path !== item.route) {
        this.$router.push(item.route);
      }
    },

    updateSelectedFromPath(path) {
      const found = this.menuItems.find((item) => {
        return path.includes(item.route.replace("/list", ""));
      });

      if (found) {
        this.selectedLabel = found.label;
        this.selectedIcon = found.icon;
        return;
      }

      this.selectedLabel = "Product List";
      this.selectedIcon = "mdi-package-variant-closed";
    },
  },
};
</script>

<style scoped>
.product-page {
  background: #f8fafc;
  min-height: 100%;
}

.product-top-card {
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
  margin-bottom: 16px;
}

.product-header {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.product-title-wrap {
  display: flex;
  align-items: center;
}

.product-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.product-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.product-route-content {
  padding: 0;
}

.product-menu {
  min-width: 240px;
}

.active-menu-item {
  background: #eff6ff;
}

.active-menu-item .v-list-item__title,
.active-menu-item .v-icon {
  color: #2563eb;
  font-weight: 800;
}

@media (max-width: 600px) {
  .product-page {
    padding: 10px !important;
  }

  .product-header {
    align-items: flex-start;
  }
}
</style>